export const USER_CALL_FETCH_REQUEST = 'user-call-fetch-request';
export const USER_CALL_FETCH_SUCCESS = 'user-call-fetch-success';
export const USER_CALL_FETCH_FAILURE = 'user-call-fetch-failure';